export interface State {
    id: number;
    name: string;
    code: number;
    active: boolean
  };

export var displayColumns = [
  'name',
  'code'
]
export var displayHeaders = [
  'Name',
  'Code'
]

// actual database columns
export var orderByColumns = [
  'name',
  'code'
]

// for dropdown the options are set via ts file, so modify the code there
export const filterParameters = [
  { 
      name: 'created_at', 
      type: 'date_range', 
      operator: 'between', 
      label: 'Select Date Range' 
  },
  { 
      name: 'name', 
      type: 'string', 
      operator: 'like', 
      label: 'State', 
  },
  { 
    name: 'order_by_columns', 
    type: 'multi_select', 
    operator: 'order_by_columns',
    values: displayHeaders.map((header, index) => ({
            label: header,
            value: orderByColumns[index]
        })),
    model_name:'state',
    label: 'Select columns for order by' 
  }
  
]; 


